import Dashboard from './components/Dashboard.vue'
import SignIn from './components/SignIn.vue'
import Loading from './components/Loading.vue'
import SetupOrganization from './components/organizations/SetupOrganization.vue'
import NewOrganization from './components/organizations/NewOrganization.vue'
import AddRoles from './components/organizations/onboarding/AddRoles.vue'
import AddTeam from './components/organizations/onboarding/AddTeam.vue'
import GetStarted from './components/organizations/onboarding/GetStarted.vue'
import Welcome from './components/organizations/onboarding/Welcome.vue'
import JoinOrganization from './components/organizations/JoinOrganization.vue'
import Estimates from './components/estimates/Estimates.vue'
import Estimate from './components/estimates/Estimate.vue'
import EstimateSettings from './components/estimates/EstimateSettings.vue'
import RedFlagMenu from './components/estimates/RedFlagMenu.vue'
import NewEstimate from './components/estimates/NewEstimate.vue'
import RedFlags from './components/redflags/RedFlags.vue'
import RedFlag from './components/redflags/RedFlag.vue'
import NewRedFlag from './components/redflags/NewRedFlag.vue'
import RateListing from './components/rates/RateListing.vue'
import NewRateCard from './components/rates/NewRateCard.vue'
import NewRateGeneral from './components/rates/wizard/General.vue'
import NewRateCulture from './components/rates/wizard/Culture.vue'
import NewRateEmployees from './components/rates/wizard/Employees.vue'
import NewRateFinancials from './components/rates/wizard/Financials.vue'
import NewRateComplete from './components/rates/wizard/Complete.vue'
import NewRateSimple from './components/rates/wizard/Simple.vue'
import Rates from './components/rates/Rates.vue'
import SimpleRate from './components/rates/SimpleRate.vue'
import SimpleRateSettings from './components/rates/SimpleRateSettings.vue'
import Monthly from './components/rates/overlays/Monthly.vue'
import Sprintly from './components/rates/overlays/Sprintly.vue'
import Weekly from './components/rates/overlays/Weekly.vue'
import Daily from './components/rates/overlays/Daily.vue'
import Hourly from './components/rates/overlays/Hourly.vue'
import Ar from './components/rates/overlays/OverlayAr.vue'
import Acs from './components/rates/overlays/OverlayAcs.vue'
import Rfte from './components/rates/overlays/OverlayRfte.vue'
import Settings from './components/settings/Settings.vue'
import Members from './components/settings/Members.vue'
import OrganizationSwitch from './components/organizations/SwitchOrganization.vue'
import Manual from './components/manual/Manual.vue'
import Typography from './components/manual/Typography.vue'
import Colour from './components/manual/Colour.vue'
import Buttons from './components/manual/Buttons.vue'

export const routes = [
  {
    path: '/',
    name: 'signin',
    component: SignIn
  },
  {
    path: '/loading',
    name: 'loading',
    component: Loading
  },
  {
    path: '/setup',
    name: 'setup',
    component: SetupOrganization,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'welcome',
        name: 'welcome',
        component: Welcome
      },
      {
        path: '0',
        name: 'newOrganization',
        component: NewOrganization
      },
      {
        path: '1',
        name: 'addRoles',
        component: AddRoles
      },
      {
        path: '2',
        name: 'addTeam',
        component: AddTeam
      },
      {
        path: '3',
        name: 'getStarted',
        component: GetStarted
      },
      {
        path: 'join',
        name: 'joinOrganization',
        component: JoinOrganization,
        props: (route) => ({
          inviteCode: route.query.c,
          inviteOrg: route.query.o
        })
      }
    ]
  },
  {
    path: '/organizations',
    name: 'organizationSwitch',
    component: OrganizationSwitch,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/dashboard',
    component: Dashboard,
    name: 'dashboard',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/estimates',
    name: 'estimates',
    component: Estimates,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'new',
        name: 'newEstimate',
        component: NewEstimate
      }
    ]
  },
  {
    path: '/estimates/:id',
    name: 'estimate',
    component: Estimate,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'settings',
        name: 'estimateSettings',
        component: EstimateSettings
      },
      {
        path: 'redflags',
        name: 'estimateRedFlags',
        component: RedFlagMenu
      }
    ]
  },
  {
    path: '/redflags',
    component: RedFlags,
    name: 'redflags',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'new',
        name: 'newRedFlag',
        component: NewRedFlag
      }
    ]
  },
  {
    path: '/redflags/:id',
    name: 'redflag',
    component: RedFlag,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/rates',
    name: 'rates',
    component: RateListing,
    children: [
      {
        path: 'new',
        name: 'newRateCard',
        component: NewRateCard,
        children: [
          {
            path: '0',
            name: 'newRateGeneral',
            component: NewRateGeneral
          },
          {
            path: '2/:id',
            name: 'newRateCulture',
            component: NewRateCulture
          },
          {
            path: '1/:id',
            name: 'newRateEmployees',
            component: NewRateEmployees
          },
          {
            path: '3/:id',
            name: 'newRateFinancials',
            component: NewRateFinancials
          },
          {
            path: '5/:id',
            name: 'newRateComplete',
            component: NewRateComplete
          },
          {
            path: 'simple',
            name: 'newRateSimple',
            component: NewRateSimple
          }
        ]
      }
    ]
  },
  {
    path: '/rate/:id',
    name: 'simpleRate',
    component: SimpleRate,
    children: [
      {
        path: 'settings',
        name: 'simpleRateSettings',
        component: SimpleRateSettings
      }
    ]
  },
  {
    path: '/rates/:id',
    name: 'rate',
    component: Rates,
    children: [
      {
        path: 'month',
        name: 'month',
        component: Monthly
      },
      {
        path: 'sprint',
        name: 'sprint',
        component: Sprintly
      },
      {
        path: 'week',
        name: 'week',
        component: Weekly
      },
      {
        path: 'day',
        name: 'day',
        component: Daily
      },
      {
        path: 'hour',
        name: 'hour',
        component: Hourly
      },
      {
        path: 'average-client-size',
        name: 'acs',
        component: Acs
      },
      {
        path: 'revenue-per-employee',
        name: 'rfte',
        component: Rfte
      },
      {
        path: 'annual-revenue',
        name: 'ar',
        component: Ar
      }
    ]
  },
  {
    path: '/settings',
    name: 'settings',
    components: {
      default: Settings
    },
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/members',
    name: 'members',
    component: Members,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/manual',
    name: 'manual',
    components: {
      default: Manual
    }
  },
  {
    path: '/manual/typography',
    name: 'typography',
    component: Typography
  },
  {
    path: '/manual/colour',
    name: 'colour',
    component: Colour
  },
  {
    path: '/manual/buttons',
    name: 'buttons',
    component: Buttons
  },
  {
    path: '*',
    redirect: '/'
  }
]
